'use client';

import { useAppCtxSelector, useSelector, useUiCtxSelector } from '@/core';
import { DEFAULT_FAVICON_URL, DEFAULT_OG_IMAGE_URL } from '@/utils/constants';
import { capitalizeFirstLetter } from '@knapsack/utils';

export const HeadTags = () => {
  const { title, description } = useUiCtxSelector(({ headTags }) => headTags);
  const favicon = useSelector((s) => s.db?.settings?.favicon);
  const siteId = useAppCtxSelector(({ site }) => site?.meta.siteId);
  const siteTitle = useSelector((s) => s.db?.settings?.title);

  const siteDisplayName = siteTitle || siteId;
  const siteName = siteDisplayName
    ? `${capitalizeFirstLetter(siteDisplayName)} | Knapsack`
    : 'Knapsack';

  return (
    <>
      <title>{title ? `${title} | ${siteName}` : siteName}</title>
      {description && <meta name="description" content={description} />}
      {favicon ? (
        <link id="custom-favicon" rel="icon" href={favicon} />
      ) : (
        <link id="default-favicon" rel="icon" href={DEFAULT_FAVICON_URL} />
      )}
      <meta name="application-name" content="Knapsack" />

      {/* Open Graph Meta Tags */}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image:height" content="630" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image" content={DEFAULT_OG_IMAGE_URL} />
      <meta property="og:site_name" content={siteName} />
      {title && <meta property="og:title" content={title} />}
      <meta property="og:type" content="website" />
    </>
  );
};
